<template>
  <CommonLayout ref="commonLayoutRef" header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="consts.meetingType.customer" @changeIsOperationPossible="changeIsOperationPossible">
      <div class="base-color h-100 mh-550 shadow">
        <div class="customer-info-wrap h-100">
          <h2 class="text-primary pt-3 customer-info-title">【お客様情報入力欄】</h2>
          <form method="post" action="#" class="form-horizontal" autocomplete="off">
            <div class="p-3 mb-3">
              <div class="form-group row">
                <div class="col-form-label col-sm-12 customer-info-label mb-1">
                  <h2 class="fw-bold d-inline">ご両家様名</h2>
                  <span class="required-color d-inline">（*）</span>
                </div>
                <div class="customer-info-block col-4 col-sm-4">
                  <input name="bothFamilyName1" type="text" id="bothFamilyName1" class="form-control form-control-sm meeting-input" :class="{
                    'is-invalid': v$.bothFamilyName1.$error,
                    'is-invalid-custom': v$.bothFamilyName1.$error,
                  }" v-model="state.bothFamilyName1" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                  <div class="invalid-feedback" v-for="error of v$.bothFamilyName1.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
                <div class="col-1 col-sm-1 p-2 text-center">
                  <span>・</span>
                </div>
                <div class="customer-info-block col-4 col-sm-4">
                  <input name="bothFamilyName2" type="text" id="bothFamilyName2" class="form-control form-control-sm meeting-input" :class="{
                    'is-invalid': v$.bothFamilyName2.$error,
                    'is-invalid-custom': v$.bothFamilyName2.$error,
                  }" v-model="state.bothFamilyName2" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                  <div class="invalid-feedback" v-for="error of v$.bothFamilyName2.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
                <div class="col-3 col-sm-3 p-2">
                  <span>ご両家様</span>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 customer-info-label">
                  <BFormRadioGroup v-model="state.shinroShinpu1" name= "shinroShinpu1" @change="onRadioChange('shinroShinpu1' ,$event)" :disabled="!state.isOperationPossible"
                    :class="{ 'is-invalid': v$.shinroShinpu1.$error }">
                    <BFormRadio id= "shinroShinpu1-shinro" value="shinro" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu1-shinro" class="form-check-label ms-1 customer-info-label fw-bold"
                        :style="'font-size: 2rem;' + (state.shinroShinpu1 !== 'shinro' ? 'color: gray;' : 'color: black;')">ご新郎様</label>
                    </BFormRadio>
                    <BFormRadio id="shinroShinpu1-shinpu" value="shinpu" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu1-shinpu" class="form-check-label ms-1 customer-info-label fw-bold"
                        :style="'font-size: 2rem;' + (state.shinroShinpu1 !== 'shinpu' ? 'color: gray;' : 'color: black;')">ご新婦様</label>
                    </BFormRadio>
                  </BFormRadioGroup>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="groomLastName" class="col-form-label col-sm-12">姓<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="groomLastName" type="text" id="groomLastName" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.groomLastName.$error,
                      'is-invalid-custom': v$.groomLastName.$error,
                    }" v-model="state.groomLastName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.groomLastName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="groomFirstName" class="col-form-label col-sm-12">名<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="groomFirstName" type="text" id="groomFirstName" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.groomFirstName.$error,
                      'is-invalid-custom': v$.groomFirstName.$error,
                    }" v-model="state.groomFirstName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.groomFirstName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-6 row mt-2">
                  <label for="groomLastNameKana" class="col-form-label col-sm-12">セイ</label>
                  <div class="col-sm-12">
                    <input name="groomLastNameKana" type="text" id="groomLastNameKana" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.groomLastNameKana.$error,
                      'is-invalid-custom': v$.groomLastNameKana.$error,
                    }" v-model="state.groomLastNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.groomLastNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="groomFirstNameKana" class="col-form-label col-sm-12">メイ</label>
                  <div class="col-sm-12">
                    <input name="groomFirstNameKana" type="text" id="groomFirstNameKana" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.groomFirstNameKana.$error,
                      'is-invalid-custom': v$.groomFirstNameKana.$error,
                    }" v-model="state.groomFirstNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.groomFirstNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-12 row mt-2">
                  <label for="groomPhoneNumber" class="col-form-label col-sm-12">お電話番号</label>
                  <div class="col-sm-7">
                    <input name="groomPhoneNumber" type="text" id="groomPhoneNumber" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.groomPhoneNumber.$error,
                      'is-invalid-custom': v$.groomPhoneNumber.$error,
                    }" v-model="state.groomPhoneNumber" @change="loadValidate" @blur="sendSignalingInputData" maxLength="20" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.groomPhoneNumber.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-form-label col-sm-12 customer-info-label">
                  <label class="d-inline">メールアドレス</label>
                </div>
                <div class="customer-info-block col-sm-12 row">
                  <div class="col-sm-12">
                    <input name="mailAddress" type="text" id="mailAddress" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.mailAddress.$error,
                      'is-invalid-custom': v$.mailAddress.$error,
                    }" v-model="state.mailAddress" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.mailAddress.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <h2 id="email-disp">{{state.mailAddress}}</h2>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 customer-info-label">
                  <BFormRadioGroup v-model="state.shinroShinpu2" name="shinroShinpu2" @change="onRadioChange('shinroShinpu2', $event)" :disabled="!state.isOperationPossible"
                    :class="{ 'is-invalid': v$.shinroShinpu2.$error }">
                    <BFormRadio id="shinroShinpu2-shinro" value="shinro" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu2-shinro" class="form-check-label ms-1 customer-info-label fw-bold"
                        :style="'font-size: 2rem;' + (state.shinroShinpu2 !== 'shinro' ? 'color: gray;' : 'color: black;')">ご新郎様</label>
                    </BFormRadio>
                    <BFormRadio id="shinroShinpu2-shinpu" value="shinpu" class="big_radio d-inline-flex align-items-center" style="block-size: 1.5rem; inline-size: 1.5rem; margin-top: 25%;">
                      <label for="shinroShinpu2-shinpu" class="form-check-label ms-1 customer-info-label fw-bold"
                        :style="'font-size: 2rem;' + (state.shinroShinpu2 !== 'shinpu' ? 'color: gray;' : 'color: black;')">ご新婦様</label>
                    </BFormRadio>
                  </BFormRadioGroup>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="brideLastName" class="col-form-label col-sm-12">姓<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="brideLastName" type="text" id="brideLastName" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.brideLastName.$error,
                      'is-invalid-custom': v$.brideLastName.$error,
                    }" v-model="state.brideLastName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.brideLastName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="brideFirstName" class="col-form-label col-sm-12">名<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="brideFirstName" type="text" id="brideFirstName" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.brideFirstName.$error,
                      'is-invalid-custom': v$.brideFirstName.$error,
                    }" v-model="state.brideFirstName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.brideFirstName.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-6 row mt-2">
                  <label for="brideLastNameKana" class="col-form-label col-sm-12">セイ</label>
                  <div class="col-sm-12">
                    <input name="brideLastNameKana" type="text" id="brideLastNameKana" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.brideLastNameKana.$error,
                      'is-invalid-custom': v$.brideLastNameKana.$error,
                    }" v-model="state.brideLastNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.brideLastNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="brideFirstNameKana" class="col-form-label col-sm-12">メイ</label>
                  <div class="col-sm-12">
                    <input name="brideFirstNameKana" type="text" id="brideFirstNameKana" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.brideFirstNameKana.$error,
                      'is-invalid-custom': v$.brideFirstNameKana.$error,
                    }" v-model="state.brideFirstNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.brideFirstNameKana.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-end align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-12 row mt-2">
                  <label for="bridePhoneNumber" class="col-form-label col-sm-12">お電話番号</label>
                  <div class="col-sm-7">
                    <input name="bridePhoneNumber" type="text" id="bridePhoneNumber" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.bridePhoneNumber.$error,
                      'is-invalid-custom': v$.bridePhoneNumber.$error,
                    }" v-model="state.bridePhoneNumber" @change="loadValidate" @blur="sendSignalingInputData" maxLength="20" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.bridePhoneNumber.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-form-label col-sm-12 customer-info-label">
                  <label class="d-inline">メールアドレス</label>
                </div>
                <div class="customer-info-block col-sm-12 row">
                  <div class="col-sm-12">
                    <input name="brideMailAddress" type="text" id="brideMailAddress" class="form-control form-control-sm meeting-input" :class="{
                      'is-invalid': v$.brideMailAddress.$error,
                      'is-invalid-custom': v$.brideMailAddress.$error,
                    }" v-model="state.brideMailAddress" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!state.isOperationPossible" />
                    <div class="invalid-feedback" v-for="error of v$.brideMailAddress.$errors" :key="error.$uid">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <h2 id="email-disp">{{state.brideMailAddress}}</h2>
                </div>
              </div>
            </div>
          </form>
          <div class="text-end w-100 mb-3 me-5">
            <BButton variant="primary" class="w-25 ms-3 main-button-color next-button-disabled" @click="() => { console.log('clicked next'); nextPage() }" :disabled="!state.isOperationPossible">次へ</BButton>
          </div>
        </div>
      </div>
    </CustomerMeetingLayout>
  </CommonLayout>
</template>

<script>
import { reactive, computed, ref, getCurrentInstance, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { BFormRadioGroup, BFormRadio, BButton } from 'bootstrap-vue-next'
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import CustomerInfoModel from '@/models/CustomerInfoModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import useVuelidate from '@vuelidate/core'
import { required, email, maxLength, integer, helpers } from '@vuelidate/validators'

// 日本語のカタカナチェック用カスタムバリデータ
const isKana = helpers.regex(/^[あ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ]*$/)

export default {
  name: 'CustomerMeetingInput',
  components: { CommonLayout, CustomerMeetingLayout, BFormRadioGroup, BFormRadio, BButton },

  setup (props, { emit }) {
    const router = useRouter()
    const { appContext } = getCurrentInstance()
    const { proxy } = getCurrentInstance()
    const gp = appContext?.config?.globalProperties || {}
    const config = gp.config ?? {}
    const consts = gp.consts ?? {}
    const commonLayoutRef = ref(null)
    const commonModal = ref(null)
    const onRadioChange = (name, value) => {
      sendSignalingInputData({ type: 'change', target: { id: name, name, type: 'radio', value } })
    }

    const state = reactive({
      bothFamilyName1: '',
      bothFamilyName2: '',
      shinroShinpu1: 'shinro',
      shinroShinpu2: 'shinpu',
      groomLastName: '',
      groomFirstName: '',
      groomLastNameKana: '',
      groomFirstNameKana: '',
      groomPhoneNumber: '',
      brideLastName: '',
      brideFirstName: '',
      brideLastNameKana: '',
      brideFirstNameKana: '',
      bridePhoneNumber: '',
      mailAddress: '',
      brideMailAddress: '',
      isSendFirstSignalingData: false,
      isOperationPossible: cstore.getters.isOperationPossible,
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    })

    // カスタムバリデータ：どちらかのメールアドレスが入力されていれば、もう片方は必須ではない
    const isMailAddressRequired = computed(() => helpers.withMessage(
      consts.validationMsg?.meetingInput?.mailAddress?.required || 'どちらかのメールアドレスは必須です',
      (value) => !!value || !!state.brideMailAddress
    ))

    const isBrideMailAddressRequired = computed(() => helpers.withMessage(
      consts.validationMsg?.meetingInput?.mailAddress?.required || 'どちらかのメールアドレスは必須です',
      (value) => !!value || !!state.mailAddress
    ))

    // バリデーションルールの定義
    const rules = computed(() => ({
      bothFamilyName1: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.bothFamilyName1?.required || 'ご両家様名1は必須です', required) },
      bothFamilyName2: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.bothFamilyName2?.required || 'ご両家様名2は必須です', required) },
      shinroShinpu1: { required: helpers.withMessage('新郎新婦1の選択は必須です', required) },
      groomLastName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.groomLastName?.required || '新郎様の姓は必須です', required) },
      groomFirstName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.groomFirstName?.required || '新郎様の名は必須です', required) },
      groomLastNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.groomLastNameKana?.kana || '新郎様のセイはカタカナで入力してください', isKana) },
      groomFirstNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.groomFirstNameKana?.kana || '新郎様のメイはカタカナで入力してください', isKana) },
      groomPhoneNumber: {
        // required: helpers.withMessage(consts.validationMsg?.meetingInput?.groomPhoneNumber?.required || '新郎様のお電話番号は必須です', required), // お客様画面ではrequiredは不要
        maxLength: helpers.withMessage(consts.validationMsg?.meetingInput?.groomPhoneNumber?.maxLength || '20桁以内が有効です', maxLength(20)),
        phoneNumber: helpers.withMessage(consts.validationMsg?.meetingInput?.groomPhoneNumber?.phoneNumber || '電話番号には「半角数字、+、-、スペース」のみご入力ください', helpers.regex(/^[+]?[0-9\s-]+$/))
      },
      shinroShinpu2: { required: helpers.withMessage('新郎新婦2の選択は必須です', required) },
      brideLastName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.brideLastName?.required || '新婦様の姓は必須です', required) },
      brideFirstName: { required: helpers.withMessage(consts.validationMsg?.meetingInput?.brideFirstName?.required || '新婦様の名は必須です', required) },
      brideLastNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.brideLastNameKana?.kana || '新婦様のセイはカタカナで入力してください', isKana) },
      brideFirstNameKana: { isKana: helpers.withMessage(consts.validationMsg?.meetingInput?.brideFirstNameKana?.kana || '新婦様のメイはカタカナで入力してください', isKana) },
      bridePhoneNumber: {
        // required: helpers.withMessage(consts.validationMsg?.meetingInput?.bridePhoneNumber?.required || '新婦様のお電話番号は必須です', required), // お客様画面ではrequiredは不要
        maxLength: helpers.withMessage(consts.validationMsg?.meetingInput?.bridePhoneNumber?.maxLength || '20桁以内が有効です', maxLength(20)),
        phoneNumber: helpers.withMessage(consts.validationMsg?.meetingInput?.bridePhoneNumber?.phoneNumber || '電話番号には「半角数字、+、-、スペース」のみご入力ください', helpers.regex(/^[+]?[0-9\s-]+$/))
      },
      mailAddress: {
        required: isMailAddressRequired.value, // カスタムバリデータ
        email: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.email || 'Eメールの形式ではありません', email),
        halfWidth: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.halfWidth || '半角で入力してください', helpers.regex(/^[" -~]*$/))
      },
      brideMailAddress: {
        required: isBrideMailAddressRequired.value, // カスタムバリデータ
        email: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.email || 'Eメールの形式ではありません', email),
        halfWidth: helpers.withMessage(consts.validationMsg?.meetingInput?.mailAddress?.halfWidth || '半角で入力してください', helpers.regex(/^[" -~]*$/))
      }
    }))

    const v$ = useVuelidate(rules, state)

    const getIsTargetAtendeeActive = computed(() => mstore.getters.isTargetAtendeeActive)
    const getSignalingData = computed(() => cstore.getters.signalingReceiveData)
    const getIsOperationPossible = computed(() => cstore.getters.isOperationPossible)

    watch(getIsTargetAtendeeActive, (newData) => {
      if (!state.isSendFirstSignalingData && newData) {
        sendSignalingInputData()
        state.isSendFirstSignalingData = true
      }
    })

    watch(getSignalingData, (newData, oldData) => {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(null, newData, () => {})

        if (newData['event'] === 'click') {
          if (newData['id'] === 'next') {
            if (sessionStorage.customerType === consts.customerType.guest || sessionStorage.customerType === consts.customerType.main) {
              const customerTargetPath = newData['target_path'].replace('florist', 'customer')
              signalingNextPage(customerTargetPath)
            } else {
              signalingNextPage(newData['target_path'])
            }
          }
          if (newData['id'] === 'back') {
            signalingBackPage(newData['target_path'])
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            state.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            state.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
        }

        if (!state.isOperationPossible) {
          if (newData['event'] === 'input') {
            for (const item of newData.data) {
              if (!item || !item.id) continue
              if (Object.prototype.hasOwnProperty.call(state, item.id)) {
                state[item.id] = item.value
                if (item.target) {
                  v$.value?.[item.id]?.$touch?.()
                }
                continue
              }
              const elm = document.getElementById(item.id)
              if (!elm) continue
              elm.value = item.value
              elm.dispatchEvent(new Event('input'))
              if (item.target) elm.dispatchEvent(new Event('change'))
            }
          }
        }

        if (newData['event'] === 'click') {
          if (sessionStorage.customerType !== consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              state.isOperationPossible = false
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              state.isOperationPossible = true
            }
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    })

    watch(getIsOperationPossible, (newVal) => {
      state.isOperationPossible = newVal
    })

    onMounted(() => {
      console.log('customerType:', sessionStorage.customerType)
      console.log('isOperationPossible(initial):', state.isOperationPossible, cstore.getters.isOperationPossible)
      const lastRoutePath = sessionStorage.getItem('lastRoutePath')
      if (lastRoutePath !== router.currentRoute.value.path) {
        cstore.commit('setIsOperationPossible', true)
        state.isOperationPossible = true
      }
      if (sessionStorage.customerType === consts.customerType.guest) {
        cstore.commit('setIsOperationPossible', false)
        state.isOperationPossible = false
      }

      try {
        setApiData()

        if (!state.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
          sendSignalingInputData()
          state.isSendFirstSignalingData = true
        }
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    })

    const setApiData = async () => {
      try {
        const modal = commonLayoutRef.value?.commonModalRef?.value
        const resData = await CustomerInfoModel.apiSetStore(modal, () => {})
        if (!resData) return
        Object.assign(state, {
          bothFamilyName1: resData.bothFamilyName1,
          bothFamilyName2: resData.bothFamilyName2,
          shinroShinpu1: resData.shinroShinpu1,
          shinroShinpu2: resData.shinroShinpu2,
          groomLastName: resData.groomLastName,
          groomFirstName: resData.groomFirstName,
          groomLastNameKana: resData.groomLastNameKana,
          groomFirstNameKana: resData.groomFirstNameKana,
          groomPhoneNumber: resData.groomPhoneNumber,
          brideLastName: resData.brideLastName,
          brideFirstName: resData.brideFirstName,
          brideLastNameKana: resData.brideLastNameKana,
          brideFirstNameKana: resData.brideFirstNameKana,
          bridePhoneNumber: resData.bridePhoneNumber,
          mailAddress: resData.mailAddress,
          brideMailAddress: resData.brideMailAddress
        })
        v$.value.$reset()
      } catch (err) {
        console.error('setApiData error:', err)
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    }
    const signalingKeys = [
      'bothFamilyName1', 'bothFamilyName2',
      'shinroShinpu1', 'shinroShinpu2',
      'groomLastName', 'groomFirstName', 'groomLastNameKana', 'groomFirstNameKana', 'groomPhoneNumber',
      'brideLastName', 'brideFirstName', 'brideLastNameKana', 'brideFirstNameKana', 'bridePhoneNumber',
      'mailAddress', 'brideMailAddress'
    ]

    const sendSignalingInputData = async (e) => {
      try {
        if (!state.isOperationPossible) return
        const targetId = e?.target?.id || e?.target?.name
        // validate touch
        if ((e?.type === 'blur' || e?.type === 'change') && targetId) {
          const validationKey = e?.target?.type === 'radio' ? e.target.name : targetId
          v$.value?.[validationKey]?.$touch?.()
        }
        const sendData = signalingKeys.map((id) => ({
          id,
          value: state[id]
        }))
        if (targetId) {
          const t = sendData.find(x => x.id === targetId)
          if (t) t.target = true
        }
        SignalingModel.sendInputEvent(proxy ?? null, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { timestampMs: Date.now(), error: err }, () => {})
      }
    }

    const nextPage = async () => {
      console.log('nextPage called. Starting validation.')
      const isFormValid = await v$.value.$validate()
      console.log('Validation result (isFormValid):', isFormValid)
      if (!isFormValid) {
        console.log('Form is invalid. Scrolling to first error.')
        const firstErrorElement = document.querySelector('.is-invalid')
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return false
      }

      const targetPath = '/customer/meeting/confirm'
      console.log('Form is valid. Proceeding to signaling and router push. Target path:', targetPath)
      try {
        SignalingModel.sendClickEvent('next', proxy, { 'target_path': targetPath.replace('customer', 'florist') })
        console.log('Signaling event sent.')
        state.mailAddress = state.mailAddress ? state.mailAddress.trim() : ''
        state.brideMailAddress = state.brideMailAddress ? state.brideMailAddress.trim() : ''

        cstore.commit('setBothFamilyName1', state.bothFamilyName1)
        cstore.commit('setBothFamilyName2', state.bothFamilyName2)
        cstore.commit('setGroomLastName', state.groomLastName)
        cstore.commit('setGroomFirstName', state.groomFirstName)
        cstore.commit('setGroomLastNameKana', state.groomLastNameKana)
        cstore.commit('setGroomFirstNameKana', state.groomFirstNameKana)
        cstore.commit('setGroomPhoneNumber', state.groomPhoneNumber)
        cstore.commit('setBrideLastName', state.brideLastName)
        cstore.commit('setBrideFirstName', state.brideFirstName)
        cstore.commit('setBrideLastNameKana', state.brideLastNameKana)
        cstore.commit('setBrideFirstNameKana', state.brideFirstNameKana)
        cstore.commit('setBridePhoneNumber', state.bridePhoneNumber)
        cstore.commit('setMailAddress', state.mailAddress)
        cstore.commit('setBrideMailAddress', state.brideMailAddress)
        cstore.commit('setShinroShinpu1', state.shinroShinpu1)
        cstore.commit('setShinroShinpu2', state.shinroShinpu2)
        cstore.commit('setIsOperationPossible', true)
        console.log('Store state committed. Attempting router push to:', targetPath)
        await router.push(targetPath)
        console.log('router.push called.')
      } catch (err) {
        console.error('Error in nextPage method:', err)
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingInput.nextPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
        return false
      }
    }
    const backPage = (targetPath) => {
      try {
        const customerTargetPath = targetPath || '/customer/meeting/agenda'
        SignalingModel.sendClickEvent('back', proxy, { 'target_path': customerTargetPath.replace('customer', 'florist') })
        router.push(customerTargetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    }

    const signalingNextPage = async (targetPath) => {
      try {
        if (targetPath === '/customer/meeting/confirm') {
          console.log('signalingNextPage called. Starting validation.')
          const isFormValid = await v$.value.$validate()
          console.log('Validation result (isFormValid) in signalingNextPage:', isFormValid)
          if (!isFormValid) {
            console.log('Form is invalid in signalingNextPage. Scrolling to first error.')
            const firstErrorElement = document.querySelector('.is-invalid')
            if (firstErrorElement) {
              firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            return false
          }
          cstore.commit('setBothFamilyName1', state.bothFamilyName1)
          cstore.commit('setBothFamilyName2', state.bothFamilyName2)
          cstore.commit('setGroomLastName', state.groomLastName)
          cstore.commit('setGroomFirstName', state.groomFirstName)
          cstore.commit('setGroomLastNameKana', state.groomLastNameKana)
          cstore.commit('setGroomFirstNameKana', state.groomFirstNameKana)
          cstore.commit('setGroomPhoneNumber', state.groomPhoneNumber)
          cstore.commit('setBrideLastName', state.brideLastName)
          cstore.commit('setBrideFirstName', state.brideFirstName)
          cstore.commit('setBrideLastNameKana', state.brideLastNameKana)
          cstore.commit('setBrideFirstNameKana', state.brideFirstNameKana)
          cstore.commit('setBridePhoneNumber', state.bridePhoneNumber)
          cstore.commit('setMailAddress', state.mailAddress)
          cstore.commit('setBrideMailAddress', state.brideMailAddress)
          cstore.commit('setShinroShinpu1', state.shinroShinpu1)
          cstore.commit('setShinroShinpu2', state.shinroShinpu2)
          cstore.commit('setIsOperationPossible', false)
          console.log('Store state committed in signalingNextPage. Attempting router push to:', targetPath)
        }
        router.push(targetPath)
        console.log('router.push called in signalingNextPage.')
      } catch (err) {
        console.error('Error in signalingNextPage method:', err)
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
        return false
      }
    }

    const signalingBackPage = (targetPath) => {
      try {
        const floristTargetPath = targetPath.replace('customer', 'florist')
        SignalingModel.sendClickEvent('back', proxy, { 'target_path': floristTargetPath })
        router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    }

    const loadValidate = async (e) => {
      try {
        if (e && e.target && e.target.id) {
          const validationKey = e.target.type === 'radio' ? e.target.name : e.target.id
          if (v$.value[validationKey]) {
            v$.value[validationKey].$touch()
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(null, { 'timestampMs': Date.now(), 'error': err }, () => {})
      }
    }

    const changeIsOperationPossible = (value) => {
      state.isOperationPossible = value
    }

    return {
      commonLayoutRef,
      state,
      v$,
      commonModal,
      config,
      consts,
      changeIsOperationPossible,
      setApiData,
      sendSignalingInputData,
      nextPage,
      backPage,
      signalingNextPage,
      signalingBackPage,
      loadValidate,
      onRadioChange
    }
  }
}
</script>

<style scoped type="text/css">
  label {
    margin-bottom: 1px;
  }

  input[type=radio] {
    transform: scale(2);
  }

  .form-control:disabled {
    background-color: #fff;
  }

  .next-button-disabled:disabled {
    background-color: rgb(0, 123, 255);
    color: #fff;
    opacity: 1;
  }

  .big_radio {
    accent-color: #007bff;
    top: 10px;
    margin-top: 24px;
  }
</style>
